import createIcon from '../../createIcon';

/**
 * @component @name FreeCancellation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNjIwMiAxOS43NUg0LjQxMDE2VjkuNzVIMTguNDEwMlYxNC4xM0wyMC40MTAyIDEyLjEzVjUuNzVDMjAuNDEwMiA0LjY1IDE5LjUxMDIgMy43NSAxOC40MTAyIDMuNzVIMTcuNDEwMlYxLjc1SDE1LjQxMDJWMy43NUg3LjQxMDE2VjEuNzVINS40MTAxNlYzLjc1SDQuNDEwMTZDMy4zMDAxNiAzLjc1IDIuNDIwMTYgNC42NSAyLjQyMDE2IDUuNzVMMi40MTAxNiAxOS43NUMyLjQxMDE2IDIwLjg1IDMuMzAwMTYgMjEuNzUgNC40MTAxNiAyMS43NUgxMi42MjAyTDEwLjYyMDIgMTkuNzVaTTE1Ljk1MDIgMjIuMjVMMTIuNDEwMiAxOC43MUwxMy44MjAyIDE3LjNMMTUuOTQwMiAxOS40MkwyMC4xODAyIDE1LjE4TDIxLjU5MDIgMTYuNTlMMTUuOTUwMiAyMi4yNVpNOS44MjAxNiAxMy43NUwxMS40MTAyIDE1LjM0TDEwLjAwMDIgMTYuNzVMOC40MTAxNiAxNS4xNkw2LjgyMDE2IDE2Ljc1TDUuNDEwMTYgMTUuMzRMNy4wMDAxNiAxMy43NUw1LjQxMDE2IDEyLjE2TDYuODIwMTYgMTAuNzVMOC40MTAxNiAxMi4zNEwxMC4wMDAyIDEwLjc1TDExLjQxMDIgMTIuMTZMOS44MjAxNiAxMy43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FreeCancellation = createIcon('FreeCancellation', [
  [
    'path',
    {
      d: 'M10.6202 19.75H4.41016V9.75H18.4102V14.13L20.4102 12.13V5.75C20.4102 4.65 19.5102 3.75 18.4102 3.75H17.4102V1.75H15.4102V3.75H7.41016V1.75H5.41016V3.75H4.41016C3.30016 3.75 2.42016 4.65 2.42016 5.75L2.41016 19.75C2.41016 20.85 3.30016 21.75 4.41016 21.75H12.6202L10.6202 19.75ZM15.9502 22.25L12.4102 18.71L13.8202 17.3L15.9402 19.42L20.1802 15.18L21.5902 16.59L15.9502 22.25ZM9.82016 13.75L11.4102 15.34L10.0002 16.75L8.41016 15.16L6.82016 16.75L5.41016 15.34L7.00016 13.75L5.41016 12.16L6.82016 10.75L8.41016 12.34L10.0002 10.75L11.4102 12.16L9.82016 13.75Z',
      key: '1w7gvl',
    },
  ],
]);

export default FreeCancellation;
